import React, { useState } from "react";
import {
  FiLayout,
  FiBox,
  FiMessageSquare,
  FiSettings,
  FiLogOut,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

const MENU_ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: FiLayout },
  { key: "products", label: "Products", icon: FiBox },
  { key: "messages", label: "Messages", icon: FiMessageSquare },
  { key: "settings", label: "Settings", icon: FiSettings },
];

function AdminSidebar({ activeTab, onTabChange, onLogout }) {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <aside className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="admin-sidebar-header">
        {!collapsed && <span className="admin-sidebar-logo">KRIVAEXIM</span>}
        <button
          className="admin-sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <FiChevronRight size={18} /> : <FiChevronLeft size={18} />}
        </button>
      </div>

      <nav className="admin-sidebar-nav">
        {MENU_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              className={`admin-sidebar-item ${activeTab === item.key ? "active" : ""}`}
              onClick={() => onTabChange(item.key)}
              title={collapsed ? item.label : undefined}
            >
              <span className="admin-sidebar-icon">
                <Icon size={20} />
              </span>
              {!collapsed && <span className="admin-sidebar-label">{item.label}</span>}
            </button>
          );
        })}
      </nav>

      <div className="admin-sidebar-footer">
        <button
          className="admin-sidebar-logout"
          onClick={onLogout}
          title={collapsed ? "Logout" : undefined}
        >
          <span className="admin-sidebar-icon">
            <FiLogOut size={20} />
          </span>
          {!collapsed && <span className="admin-sidebar-label">Logout</span>}
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
